import React, { FC, useContext, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';

import { toast } from 'react-toastify';
import { ToastMessage, BaseModal, Input, Button } from '@cokitchen/cokitchen-components';
import { UserProfileContext } from './context';
import { apiService } from 'utils/api';
interface CreditWalletProps {
  show: boolean;
  onClose: (withRes?: boolean) => void;
}

interface CreditWalletFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  disabled: boolean;
}

const CreditWalletFooter: FC<CreditWalletFooterProps> = ({
  onCancel,
  onConfirm,
  loading,
  disabled
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      disabled={disabled}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const CreditWalletModal: FC<CreditWalletProps> = ({ show, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const { user } = useContext(UserProfileContext);

  const creditWallet = async () => {
    setLoading(true);
    const data = {
      user_id: user?.id,
      email: user?.email,
      reason,
      amount
    };
    try {
      const res = await apiService.post('user/wallet/add', {
        data,
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });

      if (res) {
        toast(<ToastMessage type='success' message='Wallet Credited successfully' />);
        onClose(true);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Add Funds'
      titleIcon={<TitleIcon />}
      titleIconColor='info'
      onRequestClose={() => onClose()}
      footer={
        <CreditWalletFooter
          disabled={Number(amount) < 1 || !reason}
          loading={loading}
          onCancel={() => onClose()}
          onConfirm={creditWallet}
        />
      }>
      <div>
        <Input
          className='mb-2'
          type='number'
          label='Amount'
          onChange={(ev) => setAmount(ev.target.value)}
          value={amount}
          placeholder='Amount'
        />

        <Input
          className='mb-2'
          label='Reason'
          onChange={(ev) => setReason(ev.target.value)}
          value={reason}
          placeholder='Reason'
        />
      </div>
    </BaseModal>
  );
};

export default CreditWalletModal;
